import { useCallback } from "react";

import { Button, Tree } from "antd";
import styled from "styled-components";

import { IShapefileNode } from "models/projects";

import PopOver from "components/base/Popover";
import { useSystemShapefiles } from "components/org-settings/hooks/useSystemShapefiles";
import { ProjectTreeNodeT } from "components/project/layers/hooks";

import { NodeProviderWithManager } from "../../../project-layer-tree/node-manager/context/NodeProviderWithManager";
import { PromoteShapefileTreeNodeManager } from "./PromoteShapefileTreeNodeManager";

interface IShapefilePromoteOverwriteSelection {
  shapefileToOverwrite: IShapefileNode;
  setShapefileToOverwrite: (shapefile: IShapefileNode) => void;
}

function ShapefilePromoteOverwriteSelection({
  shapefileToOverwrite,
  setShapefileToOverwrite
}: IShapefilePromoteOverwriteSelection) {
  const { tree: systemShapefiles } = useSystemShapefiles();

  const customTreeNode = useCallback((node: ProjectTreeNodeT) => {
    return (
      <NodeProviderWithManager node={node} isSelectable={true}>
        <PromoteShapefileTreeNodeManager node={node} />
      </NodeProviderWithManager>
    );
  }, []);

  const onShapefileSelect = (selected) => {
    if (!selected) {
      setShapefileToOverwrite(null);
    } else if (selected?.type === "shapefile") {
      setShapefileToOverwrite(selected);
    }
  };

  return (
    <PopOver
      trigger="click"
      placement="right"
      content={
        <Tree
          selectable={true}
          multiple={false}
          treeData={systemShapefiles}
          onSelect={(_, { selectedNodes: selected }) => onShapefileSelect(selected[0])}
          selectedKeys={[shapefileToOverwrite?.shapefileId]}
          titleRender={customTreeNode}
        />
      }>
      <SelectedShapefileButton placement="right">
        {shapefileToOverwrite?.title || "Select Shapefile to Overwrite"}
      </SelectedShapefileButton>
    </PopOver>
  );
}

export default ShapefilePromoteOverwriteSelection;

const SelectedShapefileButton = styled(Button)`
  width: 100%;
  text-align: left;
  margin: 5px 0px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
`;
